/* Lavetini bee: talks (mouth sprite) when scrolled into view or tapped */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function talk(el,ms){ if(reduce||!el) return; el.classList.add('is-talking'); clearTimeout(el._t); el._t=setTimeout(function(){el.classList.remove('is-talking')},ms||1800); }
  window.lvBeeTalk=talk;
  function init(root){
    var bees=(root||document).querySelectorAll('.lv-bee:not([data-lv-init])');
    bees.forEach(function(b){
      b.setAttribute('data-lv-init','1');
      b.addEventListener('click',function(){talk(b,1600)});
      b.addEventListener('mouseenter',function(){talk(b,1200)});
    });
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){talk(e.target,2000);io.unobserve(e.target)}})},{threshold:.6});
      bees.forEach(function(b){io.observe(b)});
    }
    (root||document).querySelectorAll('[data-lv-faq]:not([data-lv-init])').forEach(function(w){
      w.setAttribute('data-lv-init','1');
      var bee=w.querySelector('.lv-bee'),bub=w.querySelector('[data-lv-bubble]');
      w.querySelectorAll('details').forEach(function(d){
        d.addEventListener('toggle',function(){
          if(!d.open) return;
          w.querySelectorAll('details[open]').forEach(function(o){if(o!==d)o.open=false});
          if(bub&&d.dataset.say){bub.textContent=d.dataset.say;bub.classList.remove('lv-pop');void bub.offsetWidth;bub.classList.add('lv-pop')}
          talk(bee,1500);
        });
      });
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',function(){init()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
